// Mostra a barra de compra quando o botão de verdade sai de vista.
//
// Usa IntersectionObserver em vez de escutar o scroll: o navegador avisa só
// quando o estado muda, sem rodar código a cada pixel rolado.
(() => {
  const barra = document.querySelector('[data-barra-compra]');
  const botaoReal = document.querySelector('.product-form__submit');
  if (!barra || !botaoReal) return;

  const observador = new IntersectionObserver(
    ([entrada]) => barra.classList.toggle('barra-compra--visivel', !entrada.isIntersecting),
    { rootMargin: '0px 0px -80px 0px' }
  );
  observador.observe(botaoReal);

  barra.querySelector('[data-barra-ir]')?.addEventListener('click', () => {
    // Leva ao formulário em vez de comprar direto: a peça é personalizada e
    // os campos precisam ser preenchidos antes.
    const alvo = document.querySelector('[data-perso-grupo]') || botaoReal;
    alvo.scrollIntoView({ behavior: 'smooth', block: 'center' });

    const primeiro = alvo.querySelector('input, select, textarea');
    if (primeiro) setTimeout(() => primeiro.focus({ preventScroll: true }), 500);
  });
})();
